import React from "react";
import type { DpCredentialStatus } from "../api/credentialsApi";

/**
 * Situação do acesso ao app, do ponto de vista do DP.
 *
 * A ordem das checagens é a ordem em que os estados se sobrepõem na prática:
 * desativado vence bloqueio (um acesso desativado não "desbloqueia" sozinho), e
 * bloqueio vence "primeiro acesso pendente" (o colaborador já tentou entrar).
 */
export function credentialStateOf(
  credential?: DpCredentialStatus | null
): { label: string; modifier: string } {
  if (!credential?.exists) return { label: "Sem acesso", modifier: "dpBadge--gray" };
  if (credential.disabledAt) return { label: "Desativado", modifier: "dpBadge--red" };
  if (credential.isLocked) return { label: "Bloqueado", modifier: "dpBadge--orange" };
  if (credential.isFirstLogin) {
    return { label: "Primeiro acesso pendente", modifier: "dpBadge--blue" };
  }
  return { label: "Ativo", modifier: "dpBadge--green" };
}

const CredentialStatusBadge: React.FC<{ credential?: DpCredentialStatus | null }> = ({
  credential,
}) => {
  const { label, modifier } = credentialStateOf(credential);
  return <span className={`dpBadge ${modifier}`}>{label}</span>;
};

export default CredentialStatusBadge;
